import React from 'react';
import Paginations from '../common/paginations';
import constant from '../../constant';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
const ProjectList = ({ data, setCurrentPage, limit }) => {
    const { projects, total, page } = data;
    return (
        <React.Fragment>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Project</th>
                            <th>Total Day's of Attendance Marked</th>
                            <th>Monthly Attendance</th>

                            <th>Mark Attendance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {projects?.length > 0 ? (
                            projects.map((item, index) => (
                                <React.Fragment key={index}>
                                    <tr>
                                        <td style={{ fontSize: 15, fontFamily: "nunito" }}>{(page - 1) * limit + index + 1}</td>
                                        <td>{item.PROJECT_NAME} - {item.PROJECT_CODE}
                                        </td>
                                        <td>
                                            {item.attendance_days}{" "}
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-20 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <Link
                                                        to={{
                                                            pathname: constant.Authedcomponent.attendanceMonthlyReport.url,
                                                            state: {
                                                                project: item
                                                            }
                                                        }}
                                                        title="Monthky Attendance"
                                                    ><i className="bx bx-calendar" />
                                                    </Link>
                                                </li>
                                            </ul>
                                        </td>
                                        <td>
                                            <ul className="list-inline font-size-20 contact-links mb-0">
                                                <li className="list-inline-item px-2">
                                                    <Link
                                                        to={{
                                                            pathname: constant.Authedcomponent.attendanceCreate.url,
                                                            state: {
                                                                project: item
                                                            }
                                                        }}
                                                        title="Mark Attendance"
                                                    >
                                                        <i className="bx bx-pencil" />
                                                    </Link>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>


                                </React.Fragment>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center text-muted">No project found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                range={5}
                limit={limit}
                totalCount={total}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </React.Fragment>
    );
};

export default ProjectList;
